export const HEADER_PER_PAGE_NOTIFICATIONS_AMOUNT = 5
export const NOTIFICATION_PAGE_PER_PAGE_NOTIFICATIONS_AMOUNT = 10

export default interface CustomerNotification {
  id: number
  customerId: number
  enquiryId: number
  message: string
  data: any
  priority: CustomerNotificationPriority
  bookingInfo: NotificationBookingInfo
  paymentAllowed: boolean
  type: string
  dismissed: boolean
  seen: boolean
  isReviewed: boolean
  createdAt: string
}

export enum CustomerNotificationTypes {
  BookingCancelled = 'BookingCancelled',
  PassengerCancelled = 'PassengerCancelled',
  FullPaymentRequired = 'FullPaymentRequired',
  PaymentIsOverdue = 'PaymentIsOverdue',
  FullPaymentRequiredToSecureBooking = 'FullPaymentRequiredToSecureBooking',
  DepositRequiredToSecureBooking = 'DepositRequiredToSecureBooking',
  BookingExpiresTomorrow = 'BookingExpiresTomorrow',
  BookingExpired = 'BookingExpired',
  NewMessage = 'NewMessage',
  PassengerAwaitingConfirmation = 'PassengerAwaitingConfirmation',
  PassengerConfirmed = 'PassengerConfirmed',
}

export enum CustomerNotificationPriority {
  Regular = 'Regular',
  Success = 'Success',
  Warning = 'Warning',
  Important = 'Important',
}

interface NotificationBookingInfo {
  productName: string
  directionName: string
  departure: string
}
